import mockedData from './mockedData.json'

export const getTestDisturbanceParam = () => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'test') {
        // Only mock in test environment
        return ''
    }

    const urlParams = new URLSearchParams(window.location.search)
    const message = urlParams.get('message') || ''

    if (message === 'Random') {
        switch (Math.floor(Math.random() * 5)) {
            case 0:
                return '?mock=Nine'

            case 1:
                return '?mock=Eight'

            case 2:
                return '?mock=Two'

            default:
                return '?mock=Three'
        }
    }

    switch (message) {
        case 'Nine':
            return '?mock=Nine'

        case 'Eight':
            return '?mock=Eight'

        case 'Two':
            return '?mock=Two'

        case 'Three':
            return '?mock=Three'

        default:
            return ''
    }
}

export const getMockDepartures = step => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'test') {
        // Only mock in test environment
        return null
    }

    const urlParams = new URLSearchParams(window.location.search)
    const quick = urlParams.get('quick')

    if (typeof quick !== 'string') {
        return null
    }

    const useStep = quick ? Number(quick) : step

    if (useStep === 10) {
        return mockedData.departures.firstTwo
    } else if (useStep === 9) {
        return mockedData.departures.first
    } else if (useStep === 8) {
        return mockedData.departures.next
    } else if (useStep === 7) {
        return mockedData.departures.next
    } else if (useStep === 6) {
        return mockedData.departures.last
    } else if (useStep === 5) {
        return mockedData.departures.lastTwo
    } else if (useStep === 4) {
        return mockedData.departures.default5
    } else if (useStep === 3) {
        return mockedData.departures.default4
    } else if (useStep === 2) {
        return mockedData.departures.default3
    } else if (useStep === 1) {
        return mockedData.departures.default2
    } else if (useStep === 0) {
        return mockedData.departures.default1
    }

    return null
}
